import React from 'react';

const FieldsetLabel = label => (
  <span className="vads-u-font-family--sans vads-u-font-weight--normal vads-u-font-size--source-sans-normalized vads-u-line-height--4 vads-u-margin-bottom--neg2 vads-u-display--block vads-u-color--base">
    {label}
  </span>
);

export default FieldsetLabel;
